import { __awaiter, __generator } from "tslib";
import { getWebStoreApiClient } from '../../auth/web-store-api/client/client';
export var isLoggedIn = function () { return __awaiter(void 0, void 0, void 0, function () {
    var account;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getWebStoreApiClient().onTokenAcquired];
            case 1:
                _a.sent();
                account = getWebStoreApiClient().account;
                return [2 /*return*/, !!account];
        }
    });
}); };
// Expose `isLoggedIn` to global scope
if (typeof window !== undefined) {
    window.isLoggedIn = isLoggedIn;
}
